import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=3450edeb&"
import script from "./Main.vue?vue&type=script&lang=js&"
export * from "./Main.vue?vue&type=script&lang=js&"
import style0 from "./Main.vue?vue&type=style&index=0&id=3450edeb&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3450edeb')) {
      api.createRecord('3450edeb', component.options)
    } else {
      api.reload('3450edeb', component.options)
    }
    module.hot.accept("./Main.vue?vue&type=template&id=3450edeb&", function () {
      api.rerender('3450edeb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ExpenseService/Main.vue"
export default component.exports